import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#F7F8F9] py-12 px-6" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto bg-white border border-slate-200 rounded-2xl p-8 sm:p-12">
        <Link to="/" className="text-sm text-slate-500 hover:text-[#0F7B85]">← Torna alla home</Link>
        <h1 className="font-display text-3xl sm:text-4xl text-[#0F7B85] mt-6">Informativa Privacy</h1>
        <p className="text-xs text-slate-500 mt-2">Ai sensi del Reg. UE 2016/679 (GDPR) e D.Lgs. 196/2003</p>
        <p className="text-xs text-slate-400 mt-1">Ultimo aggiornamento: febbraio 2026 · v1.0</p>

        <div className="prose prose-slate max-w-none mt-8 text-sm text-slate-700 leading-relaxed space-y-5">
          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">1. Titolare del trattamento</h2>
            <p><strong>BeSafe Broker S.r.l.</strong><br/>
            P.IVA / C.F.: 07093890825<br/>
            Iscrizione RUI: <strong>B000725320</strong> (Sezione B - Broker)<br/>
            Vigilanza: IVASS (Istituto per la Vigilanza sulle Assicurazioni)<br/>
            Email DPO: <a href="mailto:privacy@besafebroker.it" className="text-[#0F7B85] hover:underline">privacy@besafebroker.it</a></p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">2. Dati raccolti</h2>
            <p>Nell'ambito del programma <em>"Besafe ti premia — Presenta un Amico"</em> raccogliamo:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li><strong>Dati del cliente segnalatore</strong>: nome, cognome, email, telefono, polizza in corso.</li>
              <li><strong>Dati dell&apos;amico segnalato</strong>: nome, email, telefono (forniti dal segnalatore con suo consenso) e, se disponibile, targa veicolo.</li>
              <li><strong>Dati tecnici</strong>: indirizzo IP, log di accesso, cookie tecnici di sessione.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">3. Finalità del trattamento</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Gestione del programma referral e accredito dei bonus (10€ per amico sottoscritto, max 100€).</li>
              <li>Invio di comunicazioni transazionali relative al wallet e allo stato delle segnalazioni.</li>
              <li>Contatto telefonico/email dell'amico segnalato per proposta di preventivo RCA.</li>
              <li>Adempimenti contabili e fiscali.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">4. Base giuridica</h2>
            <p>Il trattamento si fonda su:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Esecuzione di un contratto (art. 6.1.b GDPR) - regolamento "Besafe ti premia".</li>
              <li>Consenso esplicito dell'interessato (art. 6.1.a) - per il segnalatore e l'amico segnalato.</li>
              <li>Obbligo legale (art. 6.1.c) - per gli adempimenti IVASS e fiscali.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">5. Conservazione dei dati</h2>
            <p>I dati delle segnalazioni vengono conservati per <strong>massimo 12 mesi</strong> dalla data di invio, dopodiché lo stato viene marcato come <em>scaduto</em>. I dati dei clienti registrati vengono conservati per la durata del rapporto contrattuale + 10 anni per obblighi fiscali/IVASS.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">6. Destinatari</h2>
            <p>I dati possono essere comunicati a:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Compagnie assicurative partner per la formulazione di preventivi.</li>
              <li>Fornitori IT (Resend per email transazionali, MongoDB Atlas per hosting database — entrambi con DPA UE).</li>
              <li>Autorità di vigilanza (IVASS) e fiscali su richiesta.</li>
            </ul>
            <p className="mt-2 text-xs text-slate-500">Non effettuiamo trasferimenti di dati al di fuori dell'UE.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">7. Diritti dell'interessato</h2>
            <p>Hai il diritto di: accedere ai tuoi dati, rettificarli, cancellarli, limitarne il trattamento, opporti al trattamento, portabilità dei dati, revocare il consenso. Per esercitarli scrivi a <a href="mailto:privacy@besafebroker.it" className="text-[#0F7B85] hover:underline">privacy@besafebroker.it</a>.</p>
            <p className="mt-2">Hai inoltre diritto di proporre reclamo al <strong>Garante Privacy</strong> (www.garanteprivacy.it).</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">8. Cookie</h2>
            <p>Il sito utilizza esclusivamente <strong>cookie tecnici essenziali</strong> per la sessione di autenticazione. Maggiori dettagli nella <a href="https://besafebroker.it/cookie-policy-ue/" target="_blank" rel="noopener noreferrer" className="text-[#0F7B85] hover:underline">Cookie Policy ufficiale</a>.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0F7B85] mt-6 mb-2">9. Sito istituzionale</h2>
            <p>Per maggiori informazioni su BeSafe Broker, i servizi offerti agli intermediari assicurativi e i contatti operativi, visita il sito ufficiale <a href="https://besafebroker.it" target="_blank" rel="noopener noreferrer" className="text-[#0F7B85] hover:underline font-semibold">besafebroker.it</a>.</p>
          </section>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-200 text-[10px] text-slate-400 leading-relaxed text-center">
          BeSafe Broker S.r.l. · P.IVA 07093890825 · RUI B000725320 · Vigilanza IVASS
        </div>
      </div>
    </div>
  );
}
